import React, { useContext, useEffect, useState } from 'react'
import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from '@mui/material'
import API from '../../../services/API'
import { GlobalContext } from '../../../App'
import AnDateField from '../../../components/DateTime/DateField'
import Attachments from '../../../components/Attachments/Attachments'

const AddEvidence = ({ onClose, onSaved }) => {
  const { setToast } = useContext(GlobalContext)
  const [qualityStatements, setQualityStatements] = useState([])
  const [title, setTitle] = useState('')
  const [qualityStatementKey, setQualityStatementKey] = useState('')
  const [evidenceCategory, setEvidenceCategory] = useState('')
  const [evidenceDate, setEvidenceDate] = useState(null)
  const [reviewDate, setReviewDate] = useState(null)
  const [notes, setNotes] = useState('')
  const [s3key, setS3key] = useState(null)
  const [saving, setSaving] = useState(false)

  useEffect(() => {
    API.get('/cqc-centre/settings').then((res) => {
      if (res.status === 200) setQualityStatements(res.data.qualityStatements)
    })
  }, [])

  const selectedStatement = qualityStatements.find((qs) => qs.key === qualityStatementKey)

  const handleSubmit = (e) => {
    e.preventDefault()
    setSaving(true)
    API.post('/cqc-centre/evidence', {
      title,
      qualityStatementKey,
      evidenceCategory: evidenceCategory || undefined,
      evidenceDate: evidenceDate?.toDate ? evidenceDate.toDate() : evidenceDate,
      reviewDate: reviewDate?.toDate ? reviewDate.toDate() : reviewDate,
      notes,
      s3key,
    })
      .then((res) => {
        if (res.status === 201) {
          setToast?.({ message: 'Evidence added' })
          onSaved?.()
        } else {
          setToast?.({ message: res.data?.error || 'Unable to add evidence', severity: 'error' })
        }
      })
      .catch((e) => console.log(e))
      .finally(() => setSaving(false))
  }

  return (
    <Stack gap={2} component="form" onSubmit={handleSubmit} sx={{ maxWidth: 520 }}>
      <Typography variant="title2">Add Evidence</Typography>
      <TextField
        label="Title"
        value={title}
        onChange={(e) => setTitle(e.target.value)}
        required
        size="small"
        autoComplete="off"
      />
      <FormControl size="small" required>
        <InputLabel>Quality Statement</InputLabel>
        <Select
          label="Quality Statement"
          value={qualityStatementKey}
          onChange={(e) => setQualityStatementKey(e.target.value)}
        >
          {qualityStatements.map((qs) => (
            <MenuItem key={qs.key} value={qs.key}>
              {qs.keyQuestion} - {qs.title}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <FormControl size="small">
        <InputLabel>Evidence Category</InputLabel>
        <Select
          label="Evidence Category"
          value={evidenceCategory}
          onChange={(e) => setEvidenceCategory(e.target.value)}
        >
          {(selectedStatement?.evidenceCategories || []).map((cat) => (
            <MenuItem key={cat} value={cat}>
              {cat}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <AnDateField label="Evidence Date" date={evidenceDate} onChange={setEvidenceDate} />
      <AnDateField label="Review / Expiry Date (optional)" date={reviewDate} onChange={setReviewDate} />
      <TextField
        label="Notes"
        value={notes}
        onChange={(e) => setNotes(e.target.value)}
        multiline
        minRows={2}
        size="small"
      />
      <Attachments
        s3folder="cqcCentre/evidence"
        existingAttachments={[]}
        actionAfterUpload={(key) => setS3key(key)}
        actionAfterDelete={() => setS3key(null)}
      />
      <Stack direction="row" gap={1} justifyContent="flex-end">
        <Button onClick={onClose}>Cancel</Button>
        <Button type="submit" variant="contained" disabled={saving || !qualityStatementKey || !evidenceDate}>
          {saving ? 'Saving…' : 'Save'}
        </Button>
      </Stack>
    </Stack>
  )
}

export default AddEvidence
